(function () {
  var COUNTRIES = ['peru', 'spain', 'ukraine', 'paraguay', 'bolivia', 'argentina',
                   'greece', 'usa', 'canada', 'italy', 'ethiopia', 'kenya'];

  function initializeTabs(options) {
    const buttons = document.querySelectorAll(options.buttonClass);
    const contents = document.querySelectorAll(options.contentClass);
    const resetButton = options.resetButtonClass ? document.querySelector(options.resetButtonClass) : null;
    const additionalTriggers = options.additionalTriggers ? document.querySelectorAll(options.additionalTriggers) : null;
    if (!buttons.length) return;
    function activateTab(index) {
      buttons.forEach(btn => btn.classList.remove('co-active', 'co-active-initial'));
      contents.forEach(content => content.classList.remove('co-active', 'co-active-initial'));
      if (additionalTriggers) {
        additionalTriggers.forEach(trigger => trigger.classList.remove('co-active', 'co-active-initial'));
      }
      buttons[index].classList.add('co-active');
      contents[index].classList.add('co-active');
      if (additionalTriggers && additionalTriggers[index]) additionalTriggers[index].classList.add('co-active');
      if (resetButton) resetButton.classList.add('co-active');
      document.body.classList.add('co-map-active');
    }
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        if (button.classList.contains('co-active')) return;
        activateTab(index);
      });
    });
    if (additionalTriggers) {
      additionalTriggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => {
          if (trigger.classList.contains('co-active')) return;
          activateTab(index);
        });
      });
    }
    if (resetButton) {
      resetButton.addEventListener('click', () => {
        buttons.forEach(btn => btn.classList.remove('co-active', 'co-active-initial'));
        contents.forEach(content => content.classList.remove('co-active', 'co-active-initial'));
        resetButton.classList.remove('co-active', 'co-active-initial');
        if (additionalTriggers) {
          additionalTriggers.forEach(trigger => trigger.classList.remove('co-active', 'co-active-initial'));
        }
        document.body.classList.remove('co-map-active');
      });
    }
  }

  // Re-runnable: the theme editor replaces the section's DOM on every edit,
  // which throws away the old listeners. Guarded so one wrapper is only bound once.
  function initSimpliMap() {
    const wrapper = document.querySelector('.co-simpli-main-wrapper');
    if (!wrapper || wrapper.dataset.coMapReady === 'true') return;
    wrapper.dataset.coMapReady = 'true';

    // location popups can be switched off in the section (countries only)
    const locationPopups = wrapper.dataset.coLocationPopups !== 'false';

    const mapBtns = document.querySelectorAll('.co-simpli-map-button');
    const overlay = document.querySelector('.co-simpli-map-overlay');
    const contents = document.querySelectorAll('.co-simpli-content');
    const reset = document.querySelector('.co-simpli-main-close');
    let lastCountryTrigger = null;

    // sync now AND after the event finishes bubbling, so it never depends on rAF
    function scheduleSync() { syncState(); setTimeout(syncState, 0); }

    function syncState() {
      mapBtns.forEach(btn => {
        const hit = btn.querySelector('.co-simpli-map-hit');
        if (hit) hit.setAttribute('aria-expanded', btn.classList.contains('co-active') ? 'true' : 'false');
      });
      document.querySelectorAll('.co-simpli-map-circle-button').forEach(b => {
        if (locationPopups) {
          b.setAttribute('aria-pressed',
            b.classList.contains('co-active') || b.classList.contains('co-active-initial') ? 'true' : 'false');
        } else {
          // inert label, not a control: not pressed, not a tab stop
          b.removeAttribute('aria-pressed');
          b.setAttribute('tabindex', '-1');
        }
      });
    }

    mapBtns.forEach((item, index) => {
      item.addEventListener('click', () => {
        if (item.classList.contains('co-active')) return;
        mapBtns.forEach(tab => tab.classList.remove('co-active'));
        contents.forEach(content => content.classList.remove('co-active'));
        item.classList.add('co-active');
        if (contents[index]) contents[index].classList.add('co-active');
        if (overlay) overlay.classList.add('co-active');
        lastCountryTrigger = item.querySelector('.co-simpli-map-hit') || item;
        scheduleSync();
      });
    });

    if (reset) {
      reset.addEventListener('click', () => {
        mapBtns.forEach(tab => tab.classList.remove('co-active'));
        contents.forEach(content => content.classList.remove('co-active'));
        overlay && overlay.classList.remove('co-active');
        document.body.classList.remove('co-map-active');
        reset.classList.remove('co-active-initial');
        scheduleSync();
      });
    }

    if (locationPopups) {
      COUNTRIES.forEach(c => initializeTabs({
        buttonClass: '.co-simpli-' + c + '-circle-button',
        contentClass: '.co-simpli-' + c + '-content-tab',
        resetButtonClass: '.co-simpli-' + c + '-content-tab-close',
        additionalTriggers: '.co-simpli-' + c + '-circle'
      }));
    }

    document.querySelectorAll('.co-simpli-map-circle-button, .co-simpli-map-circle, .co-simpli-content-tab-close')
      .forEach(b => b.addEventListener('click', () => scheduleSync()));

    wrapper.addEventListener('keydown', e => {
      if (e.key === 'Escape' && document.querySelector('.co-simpli-map-button.co-active')) {
        e.stopPropagation();
        if (reset) reset.click();
        scheduleSync();
        if (lastCountryTrigger) lastCountryTrigger.focus();
      }
    });

    syncState();
  }

  function closeMap() {
    const reset = document.querySelector('.co-simpli-main-close');
    if (reset && document.querySelector('.co-simpli-map-button.co-active')) reset.click();
  }

  function openMap(country, index) {
    const hit = document.querySelector('.co-simpli-map-' + country + ' .co-simpli-map-hit');
    if (hit) hit.click();
    if (index) {
      const btn = document.querySelector('.co-simpli-' + country + '-circle-button-' + index);
      if (btn) btn.click();
    }
    const scrollTo = document.querySelector('.co-simpli-map-' + country);
    if (scrollTo && scrollTo.scrollIntoView) scrollTo.scrollIntoView({ block: 'center', inline: 'center' });
  }

  // Which country / location does a selected editor block belong to?
  function locateBlock(el) {
    if (!el || !el.closest) return null;
    // a LOCATION block's panel lives inside .co-simpli-<country>-content-tab-<n>
    const tab = el.closest('.co-simpli-content-tab');
    if (tab) {
      const m = tab.className.match(/co-simpli-([a-z]+)-content-tab-(\d+)/);
      if (m && COUNTRIES.indexOf(m[1]) !== -1) return { country: m[1], index: parseInt(m[2], 10) };
    }
    // a COUNTRY block's root is .co-simpli-content-<country>
    const content = el.closest('.co-simpli-content');
    if (content) {
      const m = content.className.match(/co-simpli-content-([a-z]+)\b/);
      if (m && COUNTRIES.indexOf(m[1]) !== -1) return { country: m[1], index: null };
    }
    return null;
  }

  initSimpliMap();

  // ---------------- theme editor ----------------
  document.addEventListener('shopify:section:load', initSimpliMap);
  document.addEventListener('shopify:section:unload', e => {
    const w = e.target.querySelector && e.target.querySelector('.co-simpli-main-wrapper');
    if (w) delete w.dataset.coMapReady;
  });

  let closeTimer = null;
  document.addEventListener('shopify:block:select', e => {
    clearTimeout(closeTimer);            // moving between blocks must not flash closed
    initSimpliMap();
    const hit = locateBlock(e.target);
    if (hit) openMap(hit.country, hit.index);
  });
  document.addEventListener('shopify:block:deselect', e => {
    if (!locateBlock(e.target)) return;
    closeTimer = setTimeout(closeMap, 100);
  });
})();
